import navBackImgSrc from "$/nav-back.svg";
import footPrint from "$/footprint-white.svg";
// import { useRouter } from "@tanstack/react-router";
import { Portal } from "./Portal";
import { SELECTOR } from "%/constant";
import { twMerge } from "tailwind-merge";

interface HeaderProps {
  title?: string;
  hasBackBtn?: boolean;
  hasFootPrint?: boolean;
  className?: string;
  onBackClick?: () => void; // 커스텀 뒤로가기 핸들러
  rightContent?: React.ReactNode; // 타이틀 오른쪽에 표시할 컨텐츠
}
export const Header = ({
  title,
  hasBackBtn,
  hasFootPrint = false,
  className,
  onBackClick,
  rightContent,
}: HeaderProps) => {
  // const { history } = useRouter();
  
  const handleBackClick = () => {
    if (onBackClick) {
      // 커스텀 핸들러가 있으면 실행
      onBackClick();
    } else {
      // 없으면 기본 동작
      window.history.back();
    }
  };

  return (
    <header
      className={twMerge(
        "flex sticky top-0 z-10 items-center p-3 h-14 border-b-[0.5px] border-gray-200 backdrop-blur-md flex-0",
        className
      )}
    >
      {hasBackBtn && (
        <button onClick={handleBackClick} className="-mr-6">
          <img src={navBackImgSrc} alt="뒤로가기 아이콘" />
        </button>
      )}

      <span className="m-auto text-base font-bold">{title}</span>
      {rightContent && (
        <div className="absolute right-3 flex items-center">
          {rightContent}
        </div>
      )}
      {hasFootPrint && <img src={footPrint} alt="강아지 발자국" />}
    </header>
  );
};

export const LayoutHeader = (props: HeaderProps) => (
  <Portal id={SELECTOR.HEADER}>
    <Header {...props} />
  </Portal>
);
